/**
 * QuillForms Dependencies
 */

import { getDefaultThemeProperties } from '@quillforms/utils';

/*
 * Internal Dependencies
 */
import useFormContext from './use-form-context';
const useGeneralTheme = () => {
  const {
    formObj: {
      theme
    }
  } = useFormContext();
  return {
    ...getDefaultThemeProperties(),
    ...theme
  };
};
export default useGeneralTheme;
//# sourceMappingURL=use-general-theme.js.map